export const schema = {
  water_section_head_description: {
    step: 2,
    fieldType: "section_desc_field",
    description: `
		<div class="sectionX-title">Water Shortage Resiliency Measures Present
    </div>
    <p>
    You can increase your resilience to water shortages by increasing your rainwater harvesting and water storage capacity and installing water efficient appliances, investing in water reuse systems and practicing water conservation to reduce water demand. Determine what measures you already have in place at your home. Missing measures are opportunities to increase resilience!
    </p>
		`,
    wrapperStyle: {},
    fieldStyle: {},
    expandable: false,
    validations: {},
  },
  /*  water_section_head: {
    step: 2,
    fieldType: "label_field",
    label: "Water shortage resiliency measures presentWater Shortage Resiliency Measures Present",
    type: "section-head",
    wrapperStyle: {
      class: "section-head",
    },
    fieldStyle: {},
    validations: {},
  }, */
  /*
  water_section_description: {
    step: 2,
    fieldType: "label_field",
    label:
      "You can increase your resilience to water shortages by increasing your rainwater harvesting and storage capacity and installing water efficient appliances, investing in water reuse systems and practicing water conservation to reduce water demand. Determine what measures you already have in place at your home. Missing measures are opportunities to increase resilience!",
    type: "desc",
    wrapperStyle: {},
    fieldStyle: {},
    validations: {},
  },
 */
  water_resiliency_features: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    questionNum: 1,
    label: "Select measures that are present.",
    placeholder: "",
    helperText: "",
    customMod: "checkboxes",
    value: [],
    groupTag: "door",
    rFeature: "door",
    options: [
      {
        /* <a href="#" helper-id="D844">Rainwater harvesting system</a> installed (learn about options for upgrading your system here) */
        text: `Water storage tank,<a href="#" helper-id="D844"> rainwater harvesting system</a> or <a href="#" helper-id="D5921"> cistern</a> (learn about options for upgrading your system <a target="_blank" href="https://api.sldb.lc/wp-content/uploads/2021/05/Supporting-Water-Conservation-and-Use-of-Rainwater-Harvesting-in-Saint-Lucia_Training-Manual-2018.pdf">here</a>)
          `,
        value: "rainwater_harvesting_system",
      },
      {
        text: "Low-flush toilets (these are toilets that use a maximum of 1.6 gallons per flush)",
        value: "low_flush_toilet",
      },
      {
        text: "Low-flow showerheads (these are showerheads that use less than 2 gallons of water per minute)",
        value: "low_flush_showerhead",
      },
      {
        text: "Low-flow faucets (these are faucets that use a maximum of 1.5 gallons of water per minute) ",
        value: "low_flush_faucets",
      },
      {
        text: `Greywater treatment and reuse system. Learn more about greywater reuse<a target="_blank" href="https://greywateraction.org/greywater-reuse/"> here.</a>`,
        value: "greywater_treatment",
      },
      {
        text: `Water conservation practices. See WASCO's <a target='_blank' href='https://wascosaintlucia.com/p/water-conservation-tips'>Water Conservation Tips</a> for examples!`,
        value: "water_conservation",
      },
    ],

    wrapperStyle: {
      class: "col s12",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },
  water_resiliency_complete: {
    wrapperStyle: {
      class: "col s12",
    },
    step: 2,
    fieldType: "complete_field",
    sectionName: "",
    validations: {},
  },
};
